export default __webpack_public_path__ + "static/media/generationCore.f0bd2e06.jpg";